<template>
  <nav class="nav">
    <div class="container">
      <div class="nav-left">
        <router-link class="nav-item is-brand" to="/">
          <img src="../assets/images/logo.png" alt="Cinenow">
        </router-link>

        <language-switch class="nav-item is-lang"></language-switch>
      </div>

      <span class="nav-toggle" :class="{ 'is-active': active }" @click="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
      </span>

      <div class="nav-right nav-menu" :class="{ 'is-active': active }">
        <slot></slot>
      </div>
    </div>
  </nav>
</template>

<script>
import LanguageSwitch from '../components/LanguageSwitch'

export default {
  data () {
    return {
      active: false
    }
  },
  watch: {
    '$route': 'closeMenu'
  },
  methods: {
    toggleMenu: function () {
      this.active = !this.active
    },
    closeMenu: function () {
      this.active = false
    }
  },
  components: {
    LanguageSwitch
  }
}
</script>


<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

.nav {
  background: $black;
  border-bottom: 1px solid $purple;
  border-image: linear-gradient(to right, $purple 0%, $purple-bis 76%, $purple-ter 100%);
  border-image-slice: 1;
}

.nav-toggle:hover {
  background: none;
}

.nav-toggle span {
  background-color: $purple;
}

a.nav-item:hover {
  color: $primary
}

.nav-item a,
a.nav-item {
  color: $primary;

  &.is-tab {
    &:hover {
      border-top-color: rgba($primary, 0.5);
    }
  }
}

//   &.is-active {
//     border-bottom: 3px solid $primary;
//   }

//   &:not(.is-brand) {
//     background-color: $background;

//     &:not(.is-active):hover {
//       border-bottom: 1px solid $primary;
//     }
//   }
// }


.nav-item:not(.is-brand):not(.is-lang) {
  background-color: $background;
}



@media screen and (min-width: $tablet) {

  .nav-item:not(.is-brand):not(.is-lang) {
    background-color: transparent;
  }
//   .nav-item a.is-tab.is-active,
//   a.nav-item.is-tab.is-active {
//     border-bottom: 3px solid #B388FF;
//   }

//   .nav-item a,
//   a.nav-item {

//     &:not(.is-brand) {
//       background-color: transparent;

//       &:not(.is-active):hover {
//         border-bottom: 1px solid $primary;
//       }
//     }
//   }
}

</style>




// WEBPACK FOOTER //
// NavBar.vue?8941095c